import { render, staticRenderFns } from "./AllSchemas.vue?vue&type=template&id=742a1848"
import script from "./AllSchemas.vue?vue&type=script&lang=ts"
export * from "./AllSchemas.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports